import { render, staticRenderFns } from "./SpreadsheetEditor.vue?vue&type=template&id=68baaea6&scoped=true"
import script from "./SpreadsheetEditor.vue?vue&type=script&setup=true&lang=ts"
export * from "./SpreadsheetEditor.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./SpreadsheetEditor.vue?vue&type=style&index=0&id=68baaea6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68baaea6",
  null
  
)

export default component.exports